import Layout from "@/layout";
var dauStatsRouter = {
  path: "/dauStats",
  component: Layout,
  redirect: "/dauStats/index",
  name: "dauStats",
  alwaysShow: true,
  meta: {
    title: "日活统计",
    icon: "chart"
  },
  children: [{
    path: "index",
    name: "dauStatsIndex",
    meta: {
      title: "用户数据大盘"
    },
    component: function component() {
      return import("@/views/dauStats/index");
    }
  }]
};
export default dauStatsRouter;